import { styled } from "@mui/material";
import { snackMachineName } from "../classes.js";
const defaultOrigin = {
  vertical: "bottom",
  horizontal: "right"
};
const Root = styled("div", {
  name: snackMachineName,
  slot: "Root",
  overridesResolver: (_, styles) => [styles.root]
})(({ theme, ownerState }) => {
  const position = ownerState?.position ?? "fixed";
  const origin = ownerState?.anchorOrigin ?? defaultOrigin;
  return {
    position,
    display: "flex",
    gap: theme.spacing(1),
    flexDirection: "column",
    width: ownerState?.width,
    pointerEvents: "none",
    "> *": {
      pointerEvents: "auto"
    },
    ...position !== "static" && {
      padding: theme.spacing(1)
    },
    ...origin.vertical === "top" && { top: 0 },
    ...origin.vertical === "bottom" && { bottom: 0 },
    ...origin.horizontal === "left" && { left: 0 },
    ...origin.horizontal === "right" && { right: 0 },
    ...origin.horizontal === "center" && {
      left: "50%",
      transform: "translateX(-50%)"
    }
  };
});
export {
  Root
};
//# sourceMappingURL=Root.js.map
